/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifErrorMessage,
  MotifTheme,
  MotifIcon,
  MotifFormField,
  MotifLabel,
  MotifDatePicker,
  MotifChip,
  MotifTooltip,
} from "@ey-xd/motif-react";
import "./CreateSkuModal.scss";
import "./UpdateSkuModal.scss";
import InputBox from "../../components/Form/InputBox/InputBox";
import SelectBox from "../../components/Form/SelectBox/SelectBox";
import {
  isHTML,
  isNumeric,
  isStringHavingSpecialChars,
  ltrimString,
  notZeroValidation,
  isPositiveValidation,
  requiredValidationForEditor,
  validateMinimumSelectableIncrement,
  getMinimumSelectableIncrementErrorMessage,
  htmlToTextWithEnter,
  requiredValidationForFields,
  isEmpty,
} from "../../utils/Validator";
import {
  CONSUMPTION_MANAGER,
  MAX_LENGTH,
  VALIDATION_ERROR_MESSAGES,
  SKU_DRAFT_OPTIONAL_FIELDS,
  RICH_TEXT_EDITOR_FIELD_NAMES,
  REQUIRED_COST_METRICS_AVIALBLE,
  MAX_LENGTH_SKU_NAME,
  SKU_NAME_HELPER_TEXT,
} from "../../Constant";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useParams } from "react-router";
import { fetchSkuConfigData } from "../../store/slices/CTDBSkuConfigSlice";
import {
  AUTO_PROVISION,
  AUTO_PROVISION_PLACEHOLDER,
  COST_INTERVAL,
  COST_INTERVAL_PLACEHOLDER,
  COMMERCIAL_PLACEHOLDER,
  COMMERCIAL_STATUS,
  COST,
  COST_CATEGORY,
  COST_CATEGORY_PLACEHOLDER,
  COST_MACRO_CATEGORY,
  COST_MACRO_CATEGORY_PLACEHOLDER,
  COST_PLACEHOLDER,
  EMPIRE_CODE_PLACEHOLDER,
  MINIMUM_SELECTABLE_INCREMENT,
  RETURNABLE,
  RETURNABLE_PLACEHOLDER,
  SKU_LONG_DESCRIPTION,
  CFO_APPROVAL,
  NO_CFO_APPROVAL,
  SKU_NAME,
  SKU_RELATION,
  SKU_RELATION_PLACEHOLDER,
  COST_METRIC,
  COST_METRIC_PLACEHOLDER,
  NSR,
  BILLING_TYPE_STATUS,
  GLOBAL_RISK_MANAGER,
  LOCAL_RISK_MANAGER,
  PRODUCT_APPROVER,
  PROVISIONING_TEAM,
  ORDER_ACKNOWLEDGEMENT,
  INDEXATION,
  INDEXATION_PLACEHOLDER,
  PREVENT_SKU_SUBMISSION,
  MISSING_FIELDS_ERROR,
  SKU_CREATION_MESSAGE,
  REQUEST_COST_CHANGE,
  NEW_COSTING,
  OLD_COST_BASIS,
  OLD_INDEXATION,
  OLD_NSR,
  OLD_COST_PUBLISH_DATE,
  NEW_COST_BASIS,
  NEW_INDEXATION,
  NEW_NSR,
  NEW_COST_PUBLISH_DATE,
  CANCEL,
  SUBMIT_FOR_APPROVAL,
  CANCEL_UPDATE_REQUEST,
  CANCEL_FOR_APPROVAL,
} from "./Constants";
import Loader from "../../components/Loader";
import { CreateSkuFormValues } from "./type";
import {
  getEditableFields,
  mapSKuDataWithApi,
  validatePercentageRange,
  downloadArtifactFile,
} from "./helper";
import {
  createSku,
  getSkuDetails,
  resetCreateSkuState,
  approveNewCost,
  cancelApprovelCost,
  fetchSKUArtifactFileData,
} from "../../store/slices/CTDBCreateSkuSlice";
import NotificationGrid from "../../components/Notification/NotificationGrid";
import { fetchSkuListAllData } from "../../store/slices/CTDBSkuListAllSlice";
import {
  formatUSDWithCommas,
  sortOptions,
  isDateDifferenceLessThenTwo,
  formattingBytes,
  getArtifactFileName,
  truncateString,
  sanitizeHTMLSpace,
} from "../../utils/common";
import { RichTextEditor } from "../../components/Form/RichTextEditor/RichTextEditor";
import MultiSelect from "../../components/MultiSelect/MultiSelect";
import { IconoirInfoCircle, IconoirDownload } from "@ey-xd/motif-icon";
import {
  convertDateStringtoDate,
  getLocalDateString,
  getLocalDateStringYYYYFormat,
} from "../../utils/dateFunction";
import { AppConfigurations } from "../../store/slices/AppConfigurationSlice";
import UserSearchSelect from "../../components/UserSearchSelect";

interface ProxyOwner {
  Name: string;
  Email: string;
}
export default function UpdateSkuModal({
  show = true,
  setShow,
  selectedSku,
  onSave,
  setIsAnySKUretired,
  hasAnyProductError,
  setReloadOnNewCreation,
}: {
  show: boolean;
  setShow: (isVisible: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSave?: (updatedComment: any) => void;
  selectedSku?: string;
  setIsAnySKUretired?: React.Dispatch<React.SetStateAction<boolean>>;
  hasAnyProductError?: boolean;
  setReloadOnNewCreation?: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [showSuccessPage, setShowSuccessPage] = useState(false);
  const [isSubmitSKULoading, setIsSubmitSKULoading] = useState(false);
  const [isSaveSKULoading, setIsSaveSKULoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [getSKUData, setGetSkuData] = useState<null | any>(null);
  const [isConfirmClicked, setIsConfirmClicked] = useState(false);
  const [localRiskMng, setLocalRiskMng] = useState<ProxyOwner[] | null>([]);
  const [globalRiskMng, setGlobalRiskMng] = useState<ProxyOwner[] | null>(null);
  const [productApproverList, setProductApproverList] = useState<
    ProxyOwner[] | null
  >(null);
  const [deploymentApproverList, setDeploymentApproverList] = useState<
    ProxyOwner[] | [] | null
  >([]);
  const [consumptionManagerList, setConsumptionManagerList] = useState<
    ProxyOwner[] | null
  >([]);
  const [costTypeRequiredError, setCostTypeRequiredError] = useState(false);
  const [isCancelCostActive, setIsCancelCostActive] = useState(false);
  const [artifactPreviewError, setArtifactPreviewError] = useState("");

  // new cost fields - display old cost data
  const [oldCost, setOldCost] = useState("");
  const [oldIndexation, setOldIndexation] = useState("");
  const [oldNSR, setOldNSR] = useState("");
  const [oldPublishDate, setOldPublishDate] = useState<Date | null>(null);
  // new cost fields
  const [showNewCostingSection, setShowNewCostingSection] = useState(false);
  const [newCost, setNewCost] = useState("");
  const [newIndexation, setNewIndexation] = useState("");
  const [newNSR, setNewNSR] = useState("");
  const [publishDate, setPublishDate] = useState<Date | null>(null);
  const [minPublishDate, setMinPublishDate] = useState<Date | null>(null);
  const [approveNewCostLoading, setApproveNewCostLoading] = useState(false);
  const [cancelApproveNewCostLoading, setCancelApproveNewCostLoading] =
    useState(false);
  const [approveNewCostError, setApproveNewCostError] = useState("");
  const [reloadSKUList, setReloadSKUList] = useState(false);

  // Separate error objects for new cost fields
  const [newCostError, setNewCostError] = useState({
    isError: false,
    message: "",
    validation: ["required"],
    label: "New Cost Basis",
  });
  const [newIndexationError, setNewIndexationError] = useState({
    isError: false,
    message: "",
    validation: ["validatePercentageRange"],
    label: "New Indexation",
  });
  const [newNSRError, setNewNSRError] = useState({
    isError: false,
    message: "",
    validation: [""],
    label: "New NSR",
  });
  const [publishDateError, setPublishDateError] = useState({
    isError: false,
    message: "",
    validation: ["required"],
    label: "Publish Date",
  });

  const param = useParams();
  const productId = param.id;

  function padNumber(num: number, length: number = 3): string {
    const numberToPad = num + 1;
    return numberToPad.toString().padStart(length, "0");
  }

  const handleDownloadArtifact = async () => {
    setArtifactPreviewError("");

    const payload = {
      Action: "downloadskuartifact",
      SkuId: getSKUData.SkuId,
      ArtifactId: getSKUData.LatestArtifactId.toString(),
    };

    try {
      const fileData = await dispatch(fetchSKUArtifactFileData(payload));
      if (fileData && fileData.payload.Status === "success") {
        downloadArtifactFile(fileData.payload.Data);
      } else {
        setArtifactPreviewError(
          "Something went wrong while downloading the CFO approval document.",
        );
      }
    } catch (error) {
      console.error("Error fetching SKU artifact:", error);
      setArtifactPreviewError(
        "Something went wrong while downloading the CFO approval document.",
      );
    }
  };

  const skuData = useSelector(
    (state: RootState) => state.CTDBSkuListAllSlice.data,
  );

  const appConfigData = useSelector(
    (state: RootState) => state.AppConfigurationSlice.configurations,
  );

  const skuLastRecord = skuData?.Result?.[0]?.SkuId || "0";
  let lastSkuNumber = 0;
  if (skuLastRecord !== "0") {
    const skuNumber = skuLastRecord.split("-")[1];
    lastSkuNumber = parseInt(skuNumber, 10);
  }

  const skuTotalNumber = padNumber(lastSkuNumber);

  const dispatch = useDispatch<AppDispatch>();

  const isconfigLoadingAPi = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.isLoading,
  );
  const configData = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.data,
  );
  const configErrorAPi = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.error,
  );

  const isSkuListLoadingAPi = useSelector(
    (state: RootState) => state.CTDBSkuListAllSlice.isLoading,
  );
  const skuListData = useSelector(
    (state: RootState) => state.CTDBSkuListAllSlice.data,
  );
  const skuListErrorAPi = useSelector(
    (state: RootState) => state.CTDBSkuListAllSlice.error,
  );
  const createSKUData = useSelector(
    (state: RootState) => state.CTDBCreateSkuSlice.data,
  );
  const createSKUErrorAPi = useSelector(
    (state: RootState) => state.CTDBCreateSkuSlice.error,
  );

  const getSKUIsLoadingAPi = useSelector(
    (state: RootState) => state.CTDBCreateSkuSlice.isLoadingDetails,
  );

  const getSKUErrorAPi = useSelector(
    (state: RootState) => state.CTDBCreateSkuSlice.errorDetails,
  );

  const skuListChild = skuListData?.Result?.filter((item: any) =>
    item.SkuRelation?.some((rel: any) => rel.ChildSkuId === selectedSku),
  );

  const isParentsActive = (skuListChild: any) => {
    if (!skuListChild || skuListChild.length === 0) return false;

    return skuListChild.some((parent: any) => parent.StatusCd === "sku_active");
  };

  const isParentActive = isParentsActive(skuListChild);

  const initialValues = {
    skuShortDescription: "",
    skuLongDescription: "",
    costCategory: "",
    chargingIncrement: "",
    returnable: "",
    costMacroCategory: "",
    minimumSelectableIncrement: "",
    cost: "",
    skuRelation: [],
    autoProvision: "",
    commercialStatus: "",
    costMetric: "",
    billingType: "",
    CostMetricNSR: "",
    Indexation: "",
  };

  const currentSku = selectedSku;

  useEffect(() => {
    setShowSuccessPage(false);
  }, []);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);

  useEffect(() => {
    dispatch(
      fetchSkuListAllData({
        search: "",
        productId: param.id || "", // Replace with actual product ID
        page: 1,
        record: 1000,
        sortOrder: "desc",
        exclude: "AutoTransact",
        sortColumn: "SkuId",
        skuRelation: true,
      }),
    );
  }, [dispatch, param.id]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formFields, setFormFields] = useState<any>(initialValues);

  const errorInitial: {
    [key: string]: {
      isError: boolean;
      message: string;
      validation: string[];
      maxLengthLimit?: number;
      label?: string;
    };
  } = {
    skuShortDescription: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    skuLongDescription: {
      isError: false,
      message: "",
      validation: ["required", "maxLength"],
      maxLengthLimit: MAX_LENGTH,
    },
    costCategory: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    chargingIncrement: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    returnable: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    costMacroCategory: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    minimumSelectableIncrement: {
      isError: false,
      message: "",
      validation: ["required", "isNumber", "isInteger", "isPositive"],
    },
    cost: {
      isError: false,
      message: "",
      validation: ["required", "isDecimal"],
    },
    skuRelation: {
      isError: false,
      message: "",
      validation: [""],
    },
    autoProvision: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    commercialStatus: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    billingType: {
      isError: false,
      message: "",
      validation: ["required"],
      label: BILLING_TYPE_STATUS,
    },
    costMetric: {
      isError: false,
      message: "",
      validation: ["required"],
    },
    CostMetricNSR: {
      isError: false,
      message: "",
      validation: [""],
      label: NSR,
    },
    Indexation: {
      isError: false,
      message: "",
      validation: ["validatePercentageRange"],
      label: INDEXATION,
    },
    deploymentApprover: {
      isError: false,
      message: "",
      validation: [""],
      label: PROVISIONING_TEAM,
    },
  };

  const [error, setError] = useState(errorInitial);

  useEffect(() => {
    if (param.id !== undefined && param.id !== null && configData === null) {
      dispatch(fetchSkuConfigData());
    }
  }, [param.id, configData]);

  useEffect(() => {
    if (param.id !== undefined && param.id !== null) {
      if (currentSku && currentSku !== "") {
        async function fetchSkuDetails() {
          const skuDetailsFetch = await dispatch(
            getSkuDetails({
              ProductId: param.id,
              SkuId: currentSku,
            }),
          );
          setError(errorInitial);
          setGetSkuData(skuDetailsFetch.payload.Data[0]);
          if (skuDetailsFetch.payload.Data[0].UpdateStatusCd) {
            setShowNewCostingSection(true);
            if (
              skuDetailsFetch.payload.Data[0].UpdateStatusCd ===
              "skuupdate_rejected"
            ) {
              const today = new Date();
              setMinPublishDate(calculateMinPublishDate(today));
            }
          }
        }
        fetchSkuDetails();
      }
    }
  }, [currentSku, show]);

  // Calculate minimum date: today + PUBLISH_DATE_IN_FUTURE_DAYS working days (excluding Saturday and Sunday)
  const calculateMinPublishDate = (startDate: Date): Date => {
    const result = new Date(startDate);
    let workingDaysAdded = 0;
    while (
      workingDaysAdded <
      ((appConfigData as AppConfigurations)?.FeatureDate?.ConfigValue as number)
    ) {
      result.setDate(result.getDate() + 1);
      const dayOfWeek = result.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        workingDaysAdded++;
      }
    }

    return result;
  };

  const checkMaxLength = (
    name: string,
    value: string,
    maxLengthLimit = MAX_LENGTH,
  ) => {
    if (value.length > maxLengthLimit) {
      setError(() => {
        return {
          ...error,
          [name]: {
            isError: true,
            message: `Maximum length should be ${maxLengthLimit} characters`,
            validation:
              errorInitial[name as keyof typeof errorInitial].validation,
            maxLengthLimit: maxLengthLimit,
          },
        };
      });
      return value.substring(0, MAX_LENGTH);
    } else {
      setError(() => {
        return {
          ...error,
          [name]: {
            isError: false,
            message: "",
            validation:
              errorInitial[name as keyof typeof errorInitial].validation,
          },
        };
      });
    }
    return value;
  };

  const {
    skuShortDescription: skuShortDescriptionError,
    skuLongDescription: skuLongDescriptionError,
    costCategory: costCategoryError,
    chargingIncrement: chargingIncrementError,
    returnable: returnableError,
    costMacroCategory: costMacroCategoryError,
    minimumSelectableIncrement: minimumSelectableIncrementError,
    cost: costError,
    skuRelation: skuRelationError,
    autoProvision: autoProvisionError,
    commercialStatus: commercialStatusError,
    billingType: billingTypeError,
    costMetric: costMetricError,
    CostMetricNSR: CostMetricNSRError,
    Indexation: IndexationError,
    deploymentApprover,
  } = error;

  const validateField = (
    name: string,
    value: string | string[],
    tempError: typeof errorInitial,
    statusType?: string,
  ): boolean | undefined => {
    const validatorArray =
      errorInitial &&
      errorInitial[name as keyof typeof errorInitial]?.validation;

    if (
      name === "skuNumber" ||
      name === "skuNumber_2" ||
      name === "skuNumber_3"
    ) {
      if (value === "" || value === undefined || value === null) {
        tempError[name] = {
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.REQUIRED,
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
        return false;
      } else {
        tempError[name] = {
          isError: false,
          message: "",
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
      }
    }
    const isDraft = statusType === "sku_draft";
    let costMerticReqError = false;
    if (isDraft && name === "costCategory" && !isEmpty(value as string)) {
      if (isEmpty(formFields?.costMetric)) {
        costMerticReqError = true;
        setCostTypeRequiredError(false);
        tempError["costMetric"] = {
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.REQUIRED,
          validation:
            errorInitial["costMetric" as keyof typeof errorInitial].validation,
        };
        setError(tempError);
        return false;
      } else {
        tempError["costMetric"] = {
          isError: false,
          message: "",
          validation:
            errorInitial["costMetric" as keyof typeof errorInitial].validation,
        };
        setError(tempError);
      }
    }

    if (isDraft && SKU_DRAFT_OPTIONAL_FIELDS.includes(name)) {
      if (name === "costCategory" && costMerticReqError) {
        return;
      }
      if (value === null || value === "") {
        tempError[name] = {
          isError: false,
          message: "",
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
      }
    }

    if (
      validatorArray &&
      validatorArray.includes("required") &&
      !(isDraft && SKU_DRAFT_OPTIONAL_FIELDS.includes(name))
    ) {
      let isValid = false;
      let hasHtml = false;
      if (RICH_TEXT_EDITOR_FIELD_NAMES.includes(name)) {
        isValid = requiredValidationForEditor(value);
      } else {
        ({ isValid, hasHtml } = requiredValidationForFields(value));
      }
      if (!isValid) {
        tempError[name] = {
          isError: true,
          message: !hasHtml
            ? VALIDATION_ERROR_MESSAGES.REQUIRED
            : VALIDATION_ERROR_MESSAGES.INVALID_CHARACTERS,
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
        return false;
      } else {
        tempError[name] = {
          isError: false,
          message: "",
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
      }
    }

    if (
      validatorArray &&
      validatorArray.includes("maxLength") &&
      !Array.isArray(value) &&
      value
    ) {
      if (isHTML(value)) {
        value = htmlToTextWithEnter(value);
      }
      const fieldError = errorInitial[name as keyof typeof errorInitial];
      let maxLengthLimit = MAX_LENGTH;
      if ("maxLengthLimit" in fieldError) {
        maxLengthLimit = fieldError.maxLengthLimit ?? MAX_LENGTH;
      }
      value = checkMaxLength(name, value, maxLengthLimit);
    }

    if (
      validatorArray &&
      validatorArray.includes("isNumber") &&
      !Array.isArray(value) &&
      value
    ) {
      if (value === null || value === "" || isNumeric(value)) {
        tempError[name] = {
          isError: false,
          message: "",
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
      } else {
        tempError[name] = {
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.MINIMUM_SELECT_INCREMENT_INT_NUM,
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
        return false;
      }
    }
    if (
      validatorArray &&
      value &&
      validatorArray.includes("validatePercentageRange") &&
      !Array.isArray(value) &&
      value &&
      value !== "%"
    ) {
      if (value === null || value === "" || validatePercentageRange(value)) {
        tempError[name] = {
          isError: false,
          message: "",
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
      } else {
        tempError[name] = {
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.PERCENTAGE_RANGE_ERROR,
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
        return false;
      }
    }

    if (
      validatorArray &&
      validatorArray.includes("notZero") &&
      !Array.isArray(value) &&
      !!value
    ) {
      if (notZeroValidation(Number(value))) {
        tempError[name] = {
          isError: false,
          message: "",
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
      } else {
        tempError[name] = {
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.MINIMUM_SELECT_INCREMENT_INT_NUM,
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
        return false;
      }
    }

    //checking positive integer validation
    if (
      validatorArray &&
      validatorArray.includes("isPositive") &&
      !Array.isArray(value) &&
      value
    ) {
      if (isPositiveValidation(Number(value))) {
        tempError[name] = {
          isError: false,
          message: "",
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
      } else {
        tempError[name] = {
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.MINIMUM_SELECT_INCREMENT_INT_NUM,
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
        return false;
      }
    }

    if (
      validatorArray &&
      validatorArray.includes("isInteger") &&
      !Array.isArray(value) &&
      value
    ) {
      if (value === null || value === "" || Number.isInteger(Number(value))) {
        tempError[name] = {
          isError: false,
          message: "",
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
      } else {
        tempError[name] = {
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.MINIMUM_SELECT_INCREMENT_INT_NUM,
          validation:
            errorInitial[name as keyof typeof errorInitial].validation,
        };
        setError(tempError);
        return false;
      }
    }

    const isMinimumSelectableIncrementField =
      name === "minimumSelectableIncrement";
    const isChargingIncrementField = name === "chargingIncrement";

    // Validate minimum selectable increment for month/week charging intervals
    if (
      ((isMinimumSelectableIncrementField &&
        ["month", "week"].includes(chargingIncrement)) ||
        (isChargingIncrementField &&
          Number(minimumSelectableIncrement) > 0 &&
          ["month", "week"].includes(value as string))) &&
      value
      // && !isDraft
    ) {
      const incrementValue = isMinimumSelectableIncrementField
        ? Number(value)
        : Number(minimumSelectableIncrement);
      const intervalType = isMinimumSelectableIncrementField
        ? chargingIncrement
        : (value as "month" | "week");

      const isValidIncrement = validateMinimumSelectableIncrement(
        incrementValue,
        intervalType,
      );

      tempError.minimumSelectableIncrement = {
        isError: !isValidIncrement,
        message: isValidIncrement
          ? ""
          : getMinimumSelectableIncrementErrorMessage(intervalType),
        validation: errorInitial.minimumSelectableIncrement.validation,
        label: MINIMUM_SELECTABLE_INCREMENT,
      };
      setError(tempError);

      if (!isValidIncrement) {
        return false;
      }
    }

    return true;
  };

  const isValidForm = (statusType: string) => {
    let isValid = true;
    const tempError = { ...errorInitial }; // Create a temporary error object
    const isNotDraft = statusType !== "sku_draft";
    for (const [key, value] of Object.entries(formFields)) {
      if (!validateField(key, value as string, tempError, statusType)) {
        isValid = false;
      }
    }

    if (
      (!deploymentApproverList || deploymentApproverList.length === 0) &&
      isNotDraft &&
      autoProvision === "0"
    ) {
      tempError.deploymentApprover = {
        isError: true,
        message: "",
        validation: ["required"],
        label: PROVISIONING_TEAM,
      };
      isValid = false;
    }
    if (!isEmpty(formFields.costCategory) && isEmpty(formFields.costMetric)) {
      isValid = false;
      tempError.costMetric = {
        isError: true,
        message: "This field is required",
        validation: ["required"],
        label: COST_METRIC,
      };
    } else {
      tempError.costMetric = {
        isError: true,
        message: "",
        validation: ["required"],
        label: COST_METRIC,
      };
    }
    if (costTypeRequiredError) {
      isValid = false;
    }
    setError(tempError); // Final state update
    return isValid;
  };

  // Validation function for new cost fields
  const validateNewCostField = (
    fieldName: "newCost" | "newIndexation" | "newNSR" | "publishDate",
    value: string | Date | null,
    errorState: typeof newCostError,
    setErrorState: React.Dispatch<React.SetStateAction<typeof newCostError>>,
  ): boolean => {
    const validatorArray = errorState.validation;

    if (validatorArray.includes("required")) {
      if (value === "" || value === undefined || value === null) {
        setErrorState({
          ...errorState,
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.REQUIRED,
        });
        return false;
      }
    }
    if (
      fieldName === "newIndexation" &&
      validatorArray.includes("validatePercentageRange") &&
      value &&
      value !== "%"
    ) {
      if (value === null || value === "" || validatePercentageRange(value)) {
        setErrorState({
          ...errorState,
          isError: false,
          message: "",
        });
      } else {
        setErrorState({
          ...errorState,
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.PERCENTAGE_RANGE_ERROR,
        });
        return false;
      }
    }

    // Clear error if validation passes
    setErrorState({
      ...errorState,
      isError: false,
      message: "",
    });
    return true;
  };

  const handleChangeSku = (selectedValue: {
    target: { name: string; value: string | string[] };
  }) => {
    const handleSingleChange = (event: {
      target: { name: string; value: string | string[] };
    }) => {
      const { name, value } = event.target;
      const val = Array.isArray(value)
        ? value.filter(
            (item: string) =>
              typeof item === "string" &&
              item !== SKU_RELATION_PLACEHOLDER &&
              item !== "",
          )
        : value;

      setFormFields(() => {
        return {
          ...formFields,
          [name]: val,
        };
      });
    };

    handleSingleChange(selectedValue);
  };

  const getSlicedSkuName = (name: string, value: string | string[]) => {
    if (name === "skuShortDescription" && value.length > MAX_LENGTH_SKU_NAME) {
      const slicedValue = value.slice(0, MAX_LENGTH_SKU_NAME);
      setFormFields(() => {
        return {
          ...formFields,
          [name]: slicedValue,
        };
      });
    }
  };

  const handleChange = (selectedValue: {
    target: { name: string; value: string | string[] };
  }) => {
    const handleSingleChange = (event: {
      target: { name: string; value: string | string[] };
    }) => {
      //const name = event.target.name;
      //const value = event.target.value;
      const tempError = { ...error };
      const { name, value } = event.target;
      let val = value;
      if (!Array.isArray(value)) {
        val = ltrimString(value);
        const tempError = { ...errorInitial }; // Create a temporary error object
        validateField(name, val as string, tempError, "sku_draft");
        if (isStringHavingSpecialChars(val) && !isHTML(val)) {
          return;
        }
      }

      if (
        (name === "CostMetricNSR" ||
          name === "cost" ||
          name === "Indexation") &&
        !Array.isArray(val)
      ) {
        val = val.replace(/[^0-9.]/g, "");
        val = val.replace(/(\..*)\./g, "$1");

        if (formatUSDWithCommas(val).length > 9) {
          if (val.endsWith(".")) {
            val = val.slice(0, -1);
          } else if (val.includes(".")) {
            const [intPart, decPart] = val.split(".");
            val = intPart.slice(0, 6) + "." + decPart.slice(0, 2);
          } else {
            val = val.slice(0, 8);
          }
        }

        if (val && val.includes(".")) {
          const [intPart, decPart] = val.split(".");
          val = intPart.slice(0, 6) + "." + decPart.slice(0, 2);
        }
      }

      if (name === "costCategory") {
        setFormFields((prevFields: CreateSkuFormValues) => ({
          ...prevFields,
          [name]: val,
          costMetric: "",
          chargingIncrement: "",
        }));
        tempError["costMetric"] = {
          isError: true,
          message: VALIDATION_ERROR_MESSAGES.REQUIRED,
          validation:
            errorInitial["costMetric" as keyof typeof errorInitial].validation,
        };
        setError(tempError);
      } else {
        setFormFields(() => {
          return {
            ...formFields,
            [name]: val,
          };
        });
      }
      if (name === "chargingIncrement") {
        setFormFields((prevFields: CreateSkuFormValues) => {
          if (formFields.chargingIncrement === "onetime" && val !== "onetime") {
            return {
              ...prevFields,
              [name]: val,
              minimumSelectableIncrement: "",
            };
          }
          if (val === "autotransact") {
            return {
              ...prevFields,
              [name]: val,
              costCategory: "Variable",
              minimumSelectableIncrement: "1",
              skuRelation: [],
              autoProvision: "1",
              returnable: "0",
            };
          }
          if (val === "onetime") {
            return {
              ...prevFields,
              [name]: val,
              costCategory: "Fixed",
              minimumSelectableIncrement: "1",
            };
          }
          return {
            ...prevFields,
            [name]: val,
          };
        });
      }
      if (
        name === "skuShortDescription" &&
        value.length > MAX_LENGTH_SKU_NAME
      ) {
        getSlicedSkuName(name, value);
      }
      if (error[name] && error[name].isError)
        validateField(name, value as string, error);
    };

    handleSingleChange(selectedValue);
  };

  useEffect(() => {
    const tempError = { ...errorInitial }; // Create a temporary error object
    if (chargingIncrement == "autotransact") {
      validateField(
        "costCategory",
        costCategory as string,
        tempError,
        "sku_draft",
      );
      validateField(
        "minimumSelectableIncrement",
        minimumSelectableIncrement as string,
        tempError,
        "sku_draft",
      );
      validateField(
        "skuRelation",
        skuRelation as string,
        tempError,
        "sku_draft",
      );
      validateField(
        "autoProvision",
        autoProvision as string,
        tempError,
        "sku_draft",
      );
      validateField("returnable", returnable as string, tempError, "sku_draft");
    }

    if (chargingIncrement == "onetime") {
      validateField(
        "costCategory",
        costCategory as string,
        tempError,
        "sku_draft",
      );
      validateField(
        "minimumSelectableIncrement",
        minimumSelectableIncrement as string,
        tempError,
        "sku_draft",
      );
    }
    getSlicedSkuName("skuShortDescription", formFields?.skuShortDescription);
  }, [formFields]);

  // Handle change for new cost fields
  const handleNewCostChange = (event: {
    target: { name: string; value: string };
  }) => {
    const { name, value } = event.target;
    let val = ltrimString(value);

    // Prevent special characters except for numbers and decimal point
    if (isStringHavingSpecialChars(val)) {
      return;
    }
    if (name === "newCost" || name === "newNSR" || name === "newIndexation") {
      val = val.replace(/[^0-9.]/g, "");
      val = val.replace(/(\..*)\./g, "$1");

      if (formatUSDWithCommas(val).length > 9) {
        if (val.endsWith(".")) {
          val = val.slice(0, -1);
        } else if (val.includes(".")) {
          const [intPart, decPart] = val.split(".");
          val = intPart.slice(0, 6) + "." + decPart.slice(0, 2);
        } else {
          val = val.slice(0, 8);
        }
      }

      if (val && val.includes(".")) {
        const [intPart, decPart] = val.split(".");
        val = intPart.slice(0, 6) + "." + decPart.slice(0, 2);
      }
    }
    if (name === "newCost") {
      setNewCost(val);
      validateNewCostField("newCost", val, newCostError, setNewCostError);
    } else if (name === "newIndexation") {
      setNewIndexation(val);
      validateNewCostField(
        "newIndexation",
        val,
        newIndexationError,
        setNewIndexationError,
      );
    } else if (name === "newNSR") {
      setNewNSR(val);
      validateNewCostField("newNSR", val, newNSRError, setNewNSRError);
    }
  };
  const handlePublishDateChange = (date: any) => {
    setPublishDate(date);
    if (date) {
      setPublishDateError({
        ...publishDateError,
        isError: false,
        message: "",
      });
    } else {
      setPublishDateError({
        ...publishDateError,
        isError: true,
        message: VALIDATION_ERROR_MESSAGES.REQUIRED,
      });
    }
  };

  const handleCalendarKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleCostChangeBlur = (event: {
    target: { name: string; value: string };
  }) => {
    const { name, value } = event.target;
    let val = value.replace(/[^0-9.]/g, ""); // Allow only digits and dot
    val = val.replace(/(\..*)\./g, "$1"); // Only one dot
    val = validateDecimalValue(val);
    if (name == "newCost") {
      setNewCost(val);
    } else if (name === "newIndexation") {
      setNewIndexation(val);
    } else if (name === "newNSR") {
      setNewNSR(val);
    }
  };

  const closeNewCostSection = () => {
    setShowNewCostingSection(false);
    setNewCost("");
    setNewIndexation("");
    setNewNSR("");
    setPublishDate(null);
    setNewCostError((prev) => ({
      ...prev,
      isError: false,
      message: "",
    }));
    setNewIndexationError((prev) => ({
      ...prev,
      isError: false,
      message: "",
    }));
    setPublishDateError((prev) => ({
      ...prev,
      isError: false,
      message: "",
    }));
  };

  const handleSKUApproval = async () => {
    setApproveNewCostError("");
    let isValid = true;
    if (
      !validateNewCostField("newCost", newCost, newCostError, setNewCostError)
    ) {
      isValid = false;
    }
    if (
      newIndexation &&
      !validateNewCostField(
        "newIndexation",
        newIndexation,
        newIndexationError,
        setNewIndexationError,
      )
    ) {
      isValid = false;
    }
    if (
      newNSR &&
      !validateNewCostField("newNSR", newNSR, newNSRError, setNewNSRError)
    ) {
      isValid = false;
    }
    if (
      !validateNewCostField(
        "publishDate",
        publishDate,
        publishDateError,
        setPublishDateError,
      )
    ) {
      isValid = false;
    }
    if (!isValid) {
      return;
    }
    try {
      setApproveNewCostLoading(true);
      const UTCpublisDate = getLocalDateStringYYYYFormat(publishDate);
      const approvalRequest = {
        Action: "submitcostupdate",
        SkuId: currentSku,
        ProductId: param.id,
        UpdateCost: newCost !== "" ? Number(newCost) : null,
        UpdateIndexation: newIndexation ? parseFloat(newIndexation) : null,
        UpdateNSR: newNSR !== "" ? Number(newNSR) : null,
        UpdatePublishDtm: UTCpublisDate || "",
      };
      const response = await dispatch(approveNewCost(approvalRequest));
      if (response.payload.Status === "success") {
        setApproveNewCostLoading(false);
        const skuDetailsFetch = await dispatch(
          getSkuDetails({
            ProductId: param.id,
            SkuId: currentSku,
          }),
        );
        setError(errorInitial);
        setGetSkuData(skuDetailsFetch.payload.Data[0]);
        if (skuDetailsFetch.payload.Data[0].UpdateStatusCd) {
          setShowNewCostingSection(true);
        }
        setReloadSKUList(true);
      } else {
        setApproveNewCostLoading(false);
        setApproveNewCostError(
          "An error occurred while approving new cost. Please try again. ",
        );
      }
    } catch (error) {
      setApproveNewCostLoading(false);
      console.error("Failed to approve new cost:", error);
      setApproveNewCostError(
        "An error occurred while approving new cost. Please try again. ",
      );
    }
  };

  const handleCancelSKUApproval = async () => {
    try {
      setCancelApproveNewCostLoading(true);
      const approvalRequest = {
        Action: "cancelCostUpdate",
        SkuId: currentSku,
      };
      const response = await dispatch(cancelApprovelCost(approvalRequest));
      if (response.payload.Status === "success") {
        setCancelApproveNewCostLoading(false);
        setIsCancelCostActive(false);
        const skuDetailsFetch = await dispatch(
          getSkuDetails({
            ProductId: param.id,
            SkuId: currentSku,
          }),
        );
        setError(errorInitial);
        setGetSkuData(skuDetailsFetch.payload.Data[0]);
        closeNewCostSection();
        setReloadSKUList(true);
      } else {
        setCancelApproveNewCostLoading(false);
        setShow(true);
        setApproveNewCostError(
          "An error occurred while Canceling new cost Request. Please try again. ",
        );
      }
    } catch (error) {
      setCancelApproveNewCostLoading(false);
      console.error("Failed to cancel new cost:", error);
      setApproveNewCostError(
        "An error occurred while Canceling new cost. Please try again. ",
      );
    }
  };

  const validateDecimalValue = (amt: any) => {
    if (amt === null || amt === undefined) {
      return "";
    }
    amt = String(amt);
    if (
      formatUSDWithCommas(amt).length > 0 &&
      formatUSDWithCommas(amt).length < 9
    ) {
      if (!amt.includes(".")) {
        // If no dot, append .00
        amt = amt + ".00";
      } else {
        const [intPart, decPart] = amt.split(".");
        const newInt = intPart || "0";
        const newDec = decPart.padEnd(2, "0").slice(0, 2); // Fill zeros if needed
        amt = newInt + "." + newDec;
      }
    }
    return amt;
  };

  const handleBlur = (event: { target: { name: string; value: string } }) => {
    const { name, value } = event.target;
    let val = value.replace(/[^0-9.]/g, ""); // Allow only digits and dot
    val = val.replace(/(\..*)\./g, "$1"); // Only one dot
    val = validateDecimalValue(val);

    setFormFields((prevFields: CreateSkuFormValues) => ({
      ...prevFields,
      [name]: val,
    }));
  };

  const confirmRetireSKU = () => {
    return (
      <>
        <MotifModal
          show={isConfirmClicked}
          onClose={() => setIsConfirmClicked(false)}
          className="confirm-retire-sku-modal"
          size="default"
          focusTrapOptions={{
            tabbableOptions: {
              displayCheck: "none",
            },
          }}
        >
          <MotifModalHeader>
            <span className="alert-text">Alert</span>
          </MotifModalHeader>
          <MotifModalBody>
            <p className="alert-desc">
              You are about to retire this SKU. Once retired, it will no longer
              be available for purchase. Please note that any existing orders
              for this SKU will continue to be billed as per the original terms.
            </p>
          </MotifModalBody>
          <MotifModalFooter>
            <MotifButton
              className="product-cancel-selection-confirm-btn"
              onClick={() => setIsConfirmClicked(false)}
              variant="secondary"
            >
              Cancel
            </MotifButton>
            <MotifButton
              className="product-cancel-selection-close-btn"
              onClick={() => handleSave("sku_retired")}
            >
              Continue
            </MotifButton>
          </MotifModalFooter>
        </MotifModal>
      </>
    );
  };
  const {
    skuShortDescription,
    skuLongDescription,
    costCategory,
    chargingIncrement,
    returnable,
    costMacroCategory,
    minimumSelectableIncrement,
    cost,
    skuRelation,
    autoProvision,
    commercialStatus,
    costMetric,
    billingType,
    CostMetricNSR,
    Indexation,
  } = formFields;

  useEffect(() => {
    if (!isEmpty(costMetric) && isEmpty(costCategory)) {
      setFormFields((prevFields: CreateSkuFormValues) => {
        return {
          ...prevFields,
          costMetric: "",
        };
      });
      setCostTypeRequiredError(true);
    }
  }, [costMetric]);

  const handleSave = async (statusType: string) => {
    try {
      const validFormStatus = isValidForm(statusType);
      if (!validFormStatus) {
        return;
      }

      const getSelectedCostCategory = configData?.CostCategory.filter(
        (item: {
          CostMetric: string;
          CostMetricType: string;
          Name: string;
          CostMetricCd: string;
        }) =>
          item.CostMetric === costMetric &&
          item.CostMetricType === costCategory,
      );

      const getSelectedCostCategoryCd =
        getSelectedCostCategory?.[0]?.CostMetricCd ?? "";
      const CostMetricCd = getSelectedCostCategoryCd || "";

      const GlobalRiskMgr = globalRiskMng;
      const LocalRiskMgr = localRiskMng;
      const ProductApprover = productApproverList;
      const DeploymentApprover = deploymentApproverList;
      let costMacroCategoryArr = [];
      if (costMacroCategory.length > 0) {
        costMacroCategoryArr = costMacroCategory.filter(
          (item: any) => item !== "all",
        );
      }

      const skuFormData: CreateSkuFormValues = {
        skuNumber: `${currentSku}`,
        productId: productId || "",
        skuShortDescription,
        skuLongDescription,
        CostMetricCd,
        chargingIncrement,
        returnable,
        costMacroCategory: costMacroCategoryArr,
        minimumSelectableIncrement,
        cost,
        skuRelation,
        autoProvision: autoProvision,
        commercialStatus: statusType,
        ProductSkuNum: Number(skuTotalNumber),
        CostMetricNSR:
          isNumeric(CostMetricNSR) && CostMetricNSR != ""
            ? Number(CostMetricNSR)
            : null,
        Indexation:
          isNumeric(Indexation) && Indexation != ""
            ? parseFloat(Indexation)
            : null,
        billingType,
        GlobalRiskMgr: GlobalRiskMgr,
        LocalRiskMgr: LocalRiskMgr,
        ProductApprover: ProductApprover,
        DeploymentApprover: DeploymentApprover,
        ConsumptionMgr: consumptionManagerList,
      };

      if (statusType === "sku_draft") {
        setIsSaveSKULoading(true);
      } else {
        setIsSubmitSKULoading(true);
      }
      const response = await dispatch(
        createSku(mapSKuDataWithApi(skuFormData, true)),
      );

      if (response.payload.Status === "success") {
        setIsSubmitSKULoading(false);
        setIsSaveSKULoading(false);
        if (statusType === "sku_retired" && setIsAnySKUretired) {
          setIsAnySKUretired(true);
        }
        if (onSave) {
          onSave("Sku has been updated successfully");
          setShow(false);
        }
      } else {
        setIsSubmitSKULoading(false);
        setIsSaveSKULoading(false);
      }
      // Add any additional logic here if needed
    } catch (error) {
      setIsSubmitSKULoading(false);
      setIsSaveSKULoading(false);
      console.log("Error in handleSave", error, showSuccessPage);
      console.log("createSKUData", createSKUData);
    }
  };

  const CostCategoryTypeOptions: { label: string; value: string }[] = [
    {
      label: COST_CATEGORY_PLACEHOLDER,
      value: "",
    },
  ];

  const CostMetricOptions: { label: string; value: string }[] = [
    {
      label: COST_METRIC_PLACEHOLDER,
      value: "",
    },
  ];
  let CommercialStatusOptions: { label: string; value: string }[] = [
    {
      label: COMMERCIAL_PLACEHOLDER,
      value: "",
    },
  ];
  let CommercialStatusOptionsRetired: { label: string; value: string }[] = [
    {
      label: COMMERCIAL_PLACEHOLDER,
      value: "",
    },
  ];
  let BillingTypeOptions: { label: string; value: string }[] = [];
  let CostMacroCategoryOptions: { label: string; value: string }[] = [];
  let ChargingIncrementOptions: { label: string; value: string }[] = [];
  let skuRelationOption: { label: string; value: string }[] = [];

  if (configData === null) {
    console.log("configData is null");
  } else {
    const {
      CostCategory,
      CommercialStatus,
      CostMacroCategory,
      ChargingIncrement,
    } = configData;

    const uniqueCostCategory: string[] = [];
    CostCategory?.forEach(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      (item: {
        Name: string;
        CostMetricType: string;
        CostMetricCd: string;
        CostMetric: string;
      }) => {
        if (costCategory === "" || costCategory === item.CostMetricType) {
          CostMetricOptions.push({
            label: item.CostMetric,
            value: item.CostMetric,
          });
        }
        if (uniqueCostCategory.includes(item.CostMetricType) === false) {
          uniqueCostCategory.push(item.CostMetricType);
          CostCategoryTypeOptions.push({
            label: item.CostMetricType,
            value: item.CostMetricType,
          });
        }
      },
    );
    const CommercialStatusFilter = CommercialStatus?.filter(
      (item: { Name: string; StatusCd: string; StatusType: string }) =>
        item.StatusType === "sku",
    );

    const CommercialStatusRetiredFilter = CommercialStatus?.filter(
      (item: { Name: string; StatusCd: string; StatusType: string }) =>
        item.StatusType === "sku" &&
        (item.StatusCd === "sku_retired" || item.StatusCd === "sku_active"),
    );

    CommercialStatusOptions = CommercialStatusFilter?.map(
      (item: { Name: string; StatusCd: string }) => ({
        label: item.Name,
        value: item.StatusCd,
        disabled: item.Name === "Draft" && getSKUData?.StatusCd !== "Draft",
      }),
    );

    CommercialStatusOptionsRetired = CommercialStatusRetiredFilter?.map(
      (item: { Name: string; StatusCd: string }) => ({
        label: item.Name,
        value: item.StatusCd,
        disabled: item.Name === "Draft" && getSKUData?.StatusCd !== "Draft",
      }),
    );

    const billingTypeFilter = CommercialStatus?.filter(
      (item: { Name: string; StatusCd: string; StatusType: string }) =>
        item.StatusType === "skubill",
    );

    BillingTypeOptions =
      billingTypeFilter?.map((item: { Name: string; StatusCd: string }) => ({
        label: item.Name,
        value: item.StatusCd,
      })) || [];

    CostMacroCategoryOptions = CostMacroCategory?.map(
      (item: { Name: string; CostMacroCategoryCd: string }) => ({
        label: item.Name,
        value: item.CostMacroCategoryCd,
      }),
    );
    ChargingIncrementOptions = ChargingIncrement?.filter(
      (item: { CostIntervalCd: string }) => {
        if (costCategory === "Variable") {
          return item.CostIntervalCd !== "onetime";
        }
        if (costCategory === "Fixed") {
          // Hide "autotransact"
          return item.CostIntervalCd !== "autotransact";
        }
        return true;
      },
    ).map((item: { Name: string; CostIntervalCd: string }) => ({
      label: item.Name,
      value: item.CostIntervalCd,
    }));

    const skuListDataParentOnly = skuListData?.Result?.filter((items: any) => {
      return items.SkuRelation.length === 0 && items.SkuId !== currentSku;
    });
    if (skuListDataParentOnly && skuListDataParentOnly.length > 0) {
      skuRelationOption = skuListDataParentOnly?.map(
        (item: { Name: string; SkuId: string }) => ({
          label: item.Name,
          value: item.SkuId,
        }),
      );
    }
  }

  const isNotAutoProvisioned = autoProvision === "0";

  const handleDeploymentApproverChange = (type: string) => {
    const isError =
      type === "remove" &&
      deploymentApproverList?.length === 1 &&
      isNotAutoProvisioned;
    setError((prevState) => ({
      ...prevState,
      deploymentApprover: {
        isError,
        message: "",
        validation: [isError ? "required" : ""],
        label: PROVISIONING_TEAM,
      },
    }));
  };

  useEffect(() => {
    if (getSKUData && getSKUData !== null && configData !== null) {
      const skuRelationSelected = Array.isArray(getSKUData?.SkuRelation)
        ? (
            getSKUData.SkuRelation as unknown as {
              SkuId: string;
              Status: string;
            }[]
          )
            .filter(
              (item) =>
                item.Status !== "sku_retired" && item.Status !== "sku_rejected",
            )
            .map((item) => item.SkuId)
        : [];

      const commercialStatus = CommercialStatusOptions?.find(
        (item) => item.label === getSKUData?.StatusCd,
      );
      const billingType = BillingTypeOptions?.find(
        (item) => item.label === getSKUData?.BillingTypeCd,
      );
      const selectedCostCategory = configData?.CostCategory?.find(
        (item: {
          CostMetricType: string;
          CostMetricCd: string;
          Name: string;
        }) => item.CostMetricCd === getSKUData?.CostMetricCd,
      );

      setGlobalRiskMng(getSKUData?.GlobalRiskMgr);
      setLocalRiskMng(getSKUData?.LocalRiskMgr);
      setProductApproverList(getSKUData?.ProductApprover);
      setDeploymentApproverList(getSKUData?.DeploymentApprover);
      setConsumptionManagerList(getSKUData?.ConsumptionMgr);

      // set new cost fields
      if (getSKUData?.UpdateStatusCd) {
        setOldCost(validateDecimalValue(getSKUData?.CostMetricCost));
        setOldNSR(validateDecimalValue(getSKUData?.CostMetricNSR));
        setOldIndexation(validateDecimalValue(getSKUData?.Indexation));
        setOldPublishDate(
          getSKUData?.oldPublishDate
            ? convertDateStringtoDate(getSKUData.oldPublishDate)
            : null,
        );
        if (
          getSKUData.UpdateStatusCd === "skuupdate_submitted" ||
          getSKUData.UpdateStatusCd === "skuupdate_pending"
        ) {
          const updatedNSR = validateDecimalValue(getSKUData?.UpdateNSR);
          const updatedIndexation =
            getSKUData?.UpdateIndexation != null
              ? validateDecimalValue(getSKUData.UpdateIndexation)
              : "";

          setNewCost(validateDecimalValue(getSKUData?.UpdateCost));
          if (getSKUData.UpdateStatusCd === "skuupdate_submitted") {
            setNewNSR(
              updatedNSR || validateDecimalValue(getSKUData?.CostMetricNSR),
            );
            setNewIndexation(
              updatedIndexation || validateDecimalValue(getSKUData?.Indexation),
            );
          } else {
            setNewNSR(updatedNSR);
            setNewIndexation(updatedIndexation);
          }
          setPublishDate(
            getSKUData?.UpdatePublishDtm
              ? convertDateStringtoDate(getSKUData.UpdatePublishDtm)
              : null,
          );
        }
      }

      setFormFields(() => {
        if (
          CostMacroCategoryOptions.length ==
          // eslint-disable-next-line no-unsafe-optional-chaining
          (getSKUData?.CostMacroCategoryCd).length
        ) {
          // eslint-disable-next-line no-unsafe-optional-chaining
          (getSKUData?.CostMacroCategoryCd).push("all");
        }

        return {
          ...formFields,
          skuShortDescription: getSKUData?.Name,
          skuLongDescription: getSKUData?.Description || "",
          costCategory: selectedCostCategory?.CostMetricType || "",
          chargingIncrement: getSKUData?.CostIntervalCd || "",
          returnable:
            getSKUData?.IsReturnable === true
              ? "1"
              : getSKUData?.IsReturnable === false
                ? "0"
                : null,
          costMacroCategory: getSKUData?.CostMacroCategoryCd || "",
          minimumSelectableIncrement: getSKUData?.CostIntervalMin || null,
          cost: validateDecimalValue(getSKUData?.CostMetricCost || 0),
          skuRelation: skuRelationSelected,
          autoProvision:
            getSKUData?.IsAutoProvisioned === true
              ? "1"
              : getSKUData?.IsAutoProvisioned === false
                ? "0"
                : null,
          commercialStatus: commercialStatus?.value,
          costMetric: selectedCostCategory?.CostMetric || "",
          CostMetricNSR: validateDecimalValue(getSKUData?.CostMetricNSR),
          Indexation: validateDecimalValue(getSKUData.Indexation),
          billingType: billingType?.value || "",
        };
      });
    }
  }, [getSKUData, configData]);

  const getNewCostStatus = (status: string | null) => {
    switch (status) {
      case "skuupdate_submitted":
        return (
          <div className="new-costing-title-wrapper">
            <span className="new-costing-title">COST UPDATE REQUEST</span>
            <MotifChip
              title="Pending Approval"
              variant="warning"
              dotSide="left"
            >
              Pending Approval
            </MotifChip>
          </div>
        );
      case "skuupdate_pending":
        return (
          <div className="new-costing-title-wrapper">
            <span className="new-costing-title">COST UPDATE REQUEST</span>
            <MotifChip
              title="Approved - Scheduled for Publish"
              variant="success"
              dotSide="left"
            >
              Approved - Scheduled for Publish
            </MotifChip>
          </div>
        );
      case "skuupdate_rejected":
        return (
          <div className="new-costing-title-wrapper">
            <span className="new-costing-title">COST UPDATE REQUEST</span>
            <MotifChip title="Rejected" variant="error" dotSide="left">
              Rejected
            </MotifChip>
          </div>
        );
      default:
        return (
          <div className="new-costing-title-wrapper">
            <span className="new-costing-title">{NEW_COSTING}</span>
          </div>
        );
    }
  };

  const getNewCostDescription = (status: string | null) => {
    switch (status) {
      case "skuupdate_submitted":
        return (
          <span>
            Your cost request is being reviewed by the BMO Office. Once
            approved, it will be published on{" "}
            <span className="bold-font">
              {getLocalDateString(
                convertDateStringtoDate(getSKUData?.UpdatePublishDtm),
              )}
            </span>
            .
          </span>
        );
      case "skuupdate_pending":
        return (
          <span>
            Your cost request has been approved by the BMO Office. It will be
            published on{" "}
            <span className="bold-font">
              {getLocalDateString(
                convertDateStringtoDate(getSKUData?.UpdatePublishDtm),
              )}
            </span>
            .
          </span>
        );
      case "skuupdate_rejected":
        return (
          <span>
            Your cost update request for{" "}
            <span className="bold-font">
              Cost Basis (${validateDecimalValue(getSKUData?.UpdateCost)}),{" "}
              {getSKUData?.UpdateIndexation
                ? `Indexation (${getSKUData.UpdateIndexation}%),` + " "
                : ""}
              {getSKUData?.UpdateNSR
                ? `NSR ($${validateDecimalValue(getSKUData?.UpdateNSR)}),` + " "
                : ""}
              Publishing Date (
              {getLocalDateString(
                convertDateStringtoDate(getSKUData?.UpdatePublishDtm),
              )}
              )
            </span>{" "}
            has been rejected because{" "}
            <span className="bold-font">"{getSKUData?.RejectReason}"</span>.
            Please rectify the issues and submit the request again below.
          </span>
        );
      default:
        return (
          <span>
            Every cost change must be approved by the BMO Office. The approval
            process can take up to{" "}
            {(appConfigData as AppConfigurations)?.FeatureDate?.ConfigValue}{" "}
            business days. Once approved, your update will be published in the
            Commercial Hub on the selected publish date.
          </span>
        );
    }
  };
  const isWeekend = (date: Date): boolean => {
    const dayOfWeek = date.getDay();
    return dayOfWeek === 0 || dayOfWeek === 6; // 0 = Sunday, 6 = Saturday
  };

  // Calculate date after N working days (excluding weekends)
  const getDateAfterWorkingDays = (
    startDate: Date,
    workingDays: number,
  ): Date => {
    const result = new Date(startDate);
    let daysAdded = 0;
    while (daysAdded < workingDays) {
      result.setDate(result.getDate() + 1);
      const dayOfWeek = result.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        daysAdded++;
      }
    }
    return result;
  };

  const getTileClassName = ({ date }: { date: Date }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dateAfter7WorkingDays = getDateAfterWorkingDays(
      today,
      (appConfigData as AppConfigurations)?.FeatureDate?.ConfigValue as number,
    );
    dateAfter7WorkingDays.setHours(0, 0, 0, 0);

    // Check if weekend and date is after 7 working days
    const dateToCheck = new Date(date);
    dateToCheck.setHours(0, 0, 0, 0);

    if (isWeekend(date) && dateToCheck >= dateAfter7WorkingDays) {
      return "min-publish-date-highlight";
    }
    if (!minPublishDate) return "";

    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);

    const compareMinDate = new Date(minPublishDate);
    compareMinDate.setHours(0, 0, 0, 0);
    const monthStart = new Date(
      compareDate.getFullYear(),
      compareDate.getMonth(),
      1,
    );
    monthStart.setHours(0, 0, 0, 0);
    if (
      compareDate.getTime() >= monthStart.getTime() &&
      compareDate.getTime() < compareMinDate.getTime()
    ) {
      return "min-publish-date-highlight";
    }
    return "";
  };

  const isDateDisabled = ({ date }: { date: Date }): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dateAfter7WorkingDays = getDateAfterWorkingDays(
      today,
      (appConfigData as AppConfigurations)?.FeatureDate?.ConfigValue as number,
    );
    dateAfter7WorkingDays.setHours(0, 0, 0, 0);

    const dateToCheck = new Date(date);
    dateToCheck.setHours(0, 0, 0, 0);

    // Disable dates before 7 working days from today
    if (dateToCheck < dateAfter7WorkingDays) {
      return true;
    }

    // Disable weekends after 7 working days
    if (dateToCheck >= dateAfter7WorkingDays && isWeekend(date)) {
      return true;
    }
    return false;
  };

  const editableFields = getEditableFields(commercialStatus);

  if (!configData) {
    return <div className="error">No data available</div>;
  }

  const hasProductError =
    hasAnyProductError &&
    (getSKUData?.StatusCd === "Draft" || getSKUData?.StatusCd === "Rejected");

  const renderCancelCostUpdateBtn = (publishDate: Date | null) => {
    return isDateDifferenceLessThenTwo(publishDate) ? (
      <MotifTooltip
        contentClassName="tooltip-content"
        allowClick
        allowHover
        id="tooltip-header-banner"
        placement="top"
        trigger={
          <MotifButton
            variant="primary"
            size="small"
            onClick={() => {
              setIsCancelCostActive(true);
            }}
            disabled={cancelApproveNewCostLoading || true}
          >
            {CANCEL_UPDATE_REQUEST}
          </MotifButton>
        }
        usePortal
        variant="default"
      >
        Canceling is only allowed two days before the publish date.
      </MotifTooltip>
    ) : (
      <MotifButton
        variant="primary"
        size="small"
        onClick={() => {
          setIsCancelCostActive(true);
        }}
      >
        {CANCEL_UPDATE_REQUEST}
      </MotifButton>
    );
  };

  return (
    <div className="create-sku-modal">
      <MotifTheme variant={"light"}></MotifTheme>
      <MotifModal
        className="createSkuModal updateSkuModal"
        id="UpdateSkuModel"
        show={show}
        onClose={() => {
          setShow(false);
          setFormFields(initialValues);
          dispatch(resetCreateSkuState());
          if (reloadSKUList) {
            setReloadOnNewCreation?.(true);
          }
        }}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <>
          <MotifModalHeader>{"SKUs"}</MotifModalHeader>
          <MotifModalBody>
            {isconfigLoadingAPi || isSkuListLoadingAPi || getSKUIsLoadingAPi ? (
              <div className="sku-modal-loader-wrapper">
                <Loader />
              </div>
            ) : configErrorAPi || getSKUErrorAPi ? (
              <div className="motif-row error-grid">
                <div className="motif-col-lg-12">
                  <div className="error">Error fetching data</div>
                </div>
              </div>
            ) : (
              <>
                {hasProductError && (
                  <div className="motif-row error-grid">
                    <div className="motif-col-lg-12">
                      <NotificationGrid
                        show={true}
                        message={MISSING_FIELDS_ERROR}
                        type="error"
                        subMessage={SKU_CREATION_MESSAGE}
                      />
                    </div>
                  </div>
                )}
                {skuListErrorAPi && (
                  <>
                    <div className="motif-row error-grid">
                      <div className="motif-col-lg-12">
                        <NotificationGrid
                          show={true}
                          message={
                            "Unexpected error occurred while getting SKU list."
                          }
                          type="error"
                        />
                      </div>
                    </div>
                  </>
                )}

                {createSKUErrorAPi && (
                  <>
                    <div className="motif-row error-grid">
                      <div className="motif-col-lg-12">
                        <NotificationGrid
                          show={true}
                          message={createSKUErrorAPi}
                          type="error"
                        />
                      </div>
                    </div>
                  </>
                )}
                {artifactPreviewError && (
                  <>
                    <div className="motif-row error-grid">
                      <div className="motif-col-lg-12">
                        <NotificationGrid
                          show={true}
                          message={artifactPreviewError}
                          type="error"
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className="motif-row heading">
                  <div className="motif-col-lg-12">
                    <div className="title">SKU Details</div>
                  </div>
                </div>
                <div className="motif-row form-item-row single-row">
                  <div className="motif-col-lg-2  form-item">
                    <div className="label">
                      {EMPIRE_CODE_PLACEHOLDER}
                      <span className="required">*</span>
                    </div>
                  </div>
                  <div className="motif-col-lg-5  form-item skuNumbertext">
                    {`${currentSku}`}
                  </div>
                </div>
                <div className="motif-row form-item-row single-row">
                  <div className="motif-col-lg-2  form-item">
                    <div className="label">
                      {SKU_NAME}
                      <span className="required">*</span>
                    </div>
                  </div>
                  <div className="motif-col-lg-10  form-item">
                    <div className="value">
                      <div className="inputField">
                        <InputBox
                          ariaLabel=""
                          label=""
                          onChange={handleChange}
                          name={"skuShortDescription"}
                          value={skuShortDescription}
                          placeholder={SKU_NAME}
                          error={skuShortDescriptionError}
                          readonly={
                            !editableFields.includes("skuShortDescription") ||
                            (!getSKUData?.UpdateStatusCd &&
                              showNewCostingSection)
                          }
                          hideClearButton={true}
                        />
                        <MotifErrorMessage
                          aria-live="assertive"
                          role="alert"
                          id="aria-error-example"
                        >
                          {skuShortDescriptionError
                            ? skuShortDescriptionError.message
                            : ""}
                        </MotifErrorMessage>
                        <div className="helper-text">
                          <div>{SKU_NAME_HELPER_TEXT}</div>
                          <div>{`${skuShortDescription?.length ?? 0} /64`}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-row form-item-row single-row">
                  <div className="motif-col-lg-2  form-item">
                    <div className="label">
                      {SKU_LONG_DESCRIPTION}
                      <span className="required">*</span>
                    </div>
                  </div>
                  <div className="motif-col-lg-10  form-item">
                    <div className="value">
                      <div className="inputField">
                        <RichTextEditor
                          name={"skuLongDescription"}
                          readOnly={
                            !editableFields.includes("skuLongDescription") ||
                            (!getSKUData?.UpdateStatusCd &&
                              showNewCostingSection)
                          }
                          value={
                            !editableFields.includes("skuLongDescription") ||
                            (!getSKUData?.UpdateStatusCd &&
                              showNewCostingSection)
                              ? sanitizeHTMLSpace(skuLongDescription)
                              : skuLongDescription
                          }
                          placeholder={SKU_LONG_DESCRIPTION}
                          handleChange={handleChange}
                          className={
                            !editableFields.includes("skuLongDescription") ||
                            (!getSKUData?.UpdateStatusCd &&
                              showNewCostingSection)
                              ? "disbaled"
                              : ""
                          }
                        />
                        <MotifErrorMessage
                          aria-live="assertive"
                          role="alert"
                          id="aria-error-example"
                        >
                          {skuLongDescriptionError
                            ? skuLongDescriptionError.message
                            : ""}
                        </MotifErrorMessage>
                      </div>
                    </div>
                  </div>
                </div>
                {getSKUData?.StatusCd === "Active" && (
                  <div className="motif-row form-item-row single-row cfo-approval-row">
                    <div className="motif-col-lg-2 form-item">
                      <div className="label">{CFO_APPROVAL}</div>
                    </div>
                    <div className="motif-col-lg-10 form-item cfo-approval-section">
                      {getSKUData?.LatestArtifactURL ? (
                        <div
                          className="file-section"
                          onClick={handleDownloadArtifact}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="file-details">
                            <MotifIcon
                              iconFunction={IconoirDownload}
                              size="20"
                              fill="#000"
                            />
                            <div>
                              <div className="file-name">
                                <MotifTooltip
                                  contentClassName="tooltip-content"
                                  allowHover
                                  allowClick={false}
                                  id={`tooltip`}
                                  placement="auto"
                                  trigger={
                                    <span
                                      aria-label="Tooltip"
                                      onClick={handleDownloadArtifact}
                                    >
                                      {truncateString(
                                        getArtifactFileName(
                                          getSKUData.LatestArtifactURL,
                                        ),
                                        69,
                                      )}
                                    </span>
                                  }
                                  usePortal
                                  variant="default"
                                  hide={
                                    getArtifactFileName(
                                      getSKUData.LatestArtifactURL,
                                    ).length <= 69
                                  }
                                >
                                  {getArtifactFileName(
                                    getSKUData.LatestArtifactURL,
                                  )}
                                </MotifTooltip>
                              </div>
                              <div className="file-size">
                                {formattingBytes(
                                  getSKUData.LatestArtifactFileSize,
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="value no-cfo-approval-title">
                          {NO_CFO_APPROVAL}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div className="motif-row heading costing-label">
                  <div className="motif-col-lg-12">
                    <div className="title">Costing</div>
                  </div>
                </div>
                <div className="motif-row form-item-row double-row">
                  <div className="motif-col-lg">
                    <div className="motif-row">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">
                          {COST_CATEGORY}
                          <span className="required">*</span>
                        </div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField">
                            <SelectBox
                              options={sortOptions(CostCategoryTypeOptions)}
                              value={costCategory}
                              // eslint-disable-next-line @typescript-eslint/no-explicit-any
                              onChange={(selectedOption: any) =>
                                handleChange({
                                  target: {
                                    name: "costCategory",
                                    value: selectedOption,
                                  },
                                })
                              }
                              searchPlaceholder={COST_CATEGORY_PLACEHOLDER}
                              multiple={false}
                              placeholder={COST_CATEGORY_PLACEHOLDER}
                              disabled={
                                !editableFields.includes("costCategory") ||
                                chargingIncrement === "onetime" ||
                                chargingIncrement === "autotransact"
                              }
                            />
                            {costCategoryError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {costCategoryError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="motif-col-lg">
                    <div className="motif-row right-content">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">
                          {COST_INTERVAL}
                          <span className="required">*</span>
                        </div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField">
                            <SelectBox
                              options={sortOptions(ChargingIncrementOptions)}
                              value={chargingIncrement}
                              // eslint-disable-next-line @typescript-eslint/no-explicit-any
                              onChange={(selectedOption: any) =>
                                handleChange({
                                  target: {
                                    name: "chargingIncrement",
                                    value: selectedOption,
                                  },
                                })
                              }
                              searchPlaceholder={COST_INTERVAL_PLACEHOLDER}
                              multiple={false}
                              placeholder={COST_INTERVAL_PLACEHOLDER}
                              disabled={
                                !editableFields.includes("chargingIncrement")
                              }
                            />
                            {chargingIncrementError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {chargingIncrementError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-row form-item-row double-row">
                  <div className="motif-col-lg">
                    <div className="motif-row">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">
                          {RETURNABLE}
                          <span className="required">*</span>
                        </div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField">
                            <SelectBox
                              options={[
                                { label: "Yes", value: "1" },
                                { label: "No", value: "0" },
                              ]}
                              value={returnable}
                              // eslint-disable-next-line @typescript-eslint/no-explicit-any
                              onChange={(selectedOption: any) =>
                                handleChange({
                                  target: {
                                    name: "returnable",
                                    value: selectedOption,
                                  },
                                })
                              }
                              searchPlaceholder={RETURNABLE_PLACEHOLDER}
                              multiple={false}
                              placeholder={RETURNABLE_PLACEHOLDER}
                              disabled={
                                !editableFields.includes("returnable") ||
                                chargingIncrement === "autotransact"
                              }
                            />
                            {returnableError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {returnableError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="motif-col-lg">
                    <div className="motif-row right-content">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">
                          {COST_MACRO_CATEGORY}
                          <span className="required">*</span>
                        </div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField">
                            <MultiSelect
                              options={CostMacroCategoryOptions}
                              value={costMacroCategory}
                              onChange={(selectedOption: any) =>
                                handleChange({
                                  target: {
                                    name: "costMacroCategory",
                                    value: selectedOption,
                                  },
                                })
                              }
                              placeholder={COST_MACRO_CATEGORY_PLACEHOLDER}
                              hasSelectAll={true}
                              selectAllLabel="Select all"
                              selectAllValue="all"
                              theme="ch-light"
                              isDisabled={
                                !editableFields.includes("costMacroCategory")
                              }
                            />
                            {costMacroCategoryError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {costMacroCategoryError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-row form-item-row double-row">
                  <div className="motif-col-lg">
                    <div className="motif-row">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">
                          {MINIMUM_SELECTABLE_INCREMENT}
                          <span className="required">*</span>
                        </div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField">
                            <InputBox
                              ariaLabel=""
                              label=""
                              onChange={handleChange}
                              name={"minimumSelectableIncrement"}
                              value={
                                chargingIncrement === "autotransact" &&
                                costCategory === "Variable"
                                  ? "1"
                                  : minimumSelectableIncrement || ""
                              }
                              placeholder={MINIMUM_SELECTABLE_INCREMENT}
                              error={minimumSelectableIncrementError}
                              readonly={
                                !editableFields.includes(
                                  "minimumSelectableIncrement",
                                ) ||
                                chargingIncrement === "onetime" ||
                                chargingIncrement === "autotransact"
                              }
                              hideClearButton={true}
                            />
                            {minimumSelectableIncrementError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {minimumSelectableIncrementError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="motif-col-lg">
                    <div className="motif-row right-content">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">
                          {COST}
                          <span className="required">*</span>
                        </div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField">
                            <InputBox
                              name={"cost"}
                              ariaLabel=""
                              label={COST}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={formatUSDWithCommas(cost || "")} // Ensure default value
                              hideClearButton={true}
                              error={costError}
                              placeholder={COST_PLACEHOLDER}
                              prefix={cost ? "$USD" : ""}
                              readonly={!editableFields.includes("cost")}
                            />
                            {costError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {costError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-row form-item-row double-row">
                  <div className="motif-col-lg hide">
                    <div className="motif-row">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">{SKU_RELATION}</div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField">
                            <SelectBox
                              options={skuRelationOption ?? []}
                              value={skuRelation}
                              onChange={(selectedOption) => {
                                handleChangeSku({
                                  target: {
                                    name: "skuRelation",
                                    value: selectedOption,
                                  },
                                });
                              }}
                              searchPlaceholder={SKU_RELATION_PLACEHOLDER}
                              multiple={true}
                              placeholder={SKU_RELATION_PLACEHOLDER}
                              disabled={
                                !editableFields.includes("skuRelation") ||
                                getSKUData.isChild ||
                                chargingIncrement === "autotransact"
                              }
                            />
                            {skuRelationError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {skuRelationError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="motif-col-lg">
                    <div className="motif-row right-content">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">
                          {AUTO_PROVISION}
                          <span className="required">*</span>
                        </div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField">
                            <SelectBox
                              options={[
                                { label: "Yes", value: "1" },
                                { label: "No", value: "0" },
                              ]}
                              value={autoProvision}
                              // eslint-disable-next-line @typescript-eslint/no-explicit-any
                              onChange={(selectedOption: any) =>
                                handleChange({
                                  target: {
                                    name: "autoProvision",
                                    value: selectedOption,
                                  },
                                })
                              }
                              searchPlaceholder={AUTO_PROVISION_PLACEHOLDER}
                              multiple={false}
                              placeholder={AUTO_PROVISION_PLACEHOLDER}
                              disabled={
                                !editableFields.includes("autoProvision") ||
                                chargingIncrement === "autotransact"
                              }
                            />
                            {autoProvisionError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {autoProvisionError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="motif-col-lg">
                    <div className="motif-row">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">
                          {BILLING_TYPE_STATUS}
                          <span className="required">*</span>
                        </div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField">
                            <SelectBox
                              options={sortOptions(BillingTypeOptions) || []}
                              value={billingType}
                              // eslint-disable-next-line @typescript-eslint/no-explicit-any
                              onChange={(selectedOption: any) =>
                                handleChange({
                                  target: {
                                    name: "billingType",
                                    value: selectedOption,
                                  },
                                })
                              }
                              searchPlaceholder={BILLING_TYPE_STATUS}
                              multiple={false}
                              placeholder={BILLING_TYPE_STATUS}
                              disabled={
                                !editableFields.includes("billingType") ||
                                (!getSKUData?.UpdateStatusCd &&
                                  showNewCostingSection)
                              }
                            />
                            {billingTypeError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {billingTypeError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-row form-item-row double-row">
                  <div className="motif-col-lg">
                    <div className="motif-row right-content">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">
                          {COST_METRIC}
                          <span className="required">*</span>
                        </div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField">
                            <SelectBox
                              options={sortOptions(CostMetricOptions) || []}
                              value={costMetric}
                              // eslint-disable-next-line @typescript-eslint/no-explicit-any
                              onChange={(selectedOption: any) =>
                                handleChange({
                                  target: {
                                    name: "costMetric",
                                    value: selectedOption,
                                  },
                                })
                              }
                              searchPlaceholder={COST_METRIC}
                              multiple={false}
                              placeholder={COST_METRIC}
                              disabled={!editableFields.includes("costMetric")}
                            />
                            {costTypeRequiredError && (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {REQUIRED_COST_METRICS_AVIALBLE}
                              </MotifErrorMessage>
                            )}
                            {costMetricError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {costMetricError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="motif-col-lg">
                    <div className="motif-row">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">{NSR}</div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField">
                            <InputBox
                              name={"CostMetricNSR"}
                              ariaLabel=""
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={formatUSDWithCommas(CostMetricNSR || "")} // Ensure default value
                              hideClearButton={true}
                              prefix="$USD"
                              placeholder={""}
                              readonly={
                                !editableFields.includes("CostMetricNSR")
                              }
                            />
                            {CostMetricNSRError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {CostMetricNSRError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-row form-item-row double-row">
                  <div className="motif-col-lg">
                    <div className="motif-row">
                      <div className="motif-col-lg-4 form-item">
                        <div className="label">{INDEXATION}</div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div className="inputField indexation-input-field">
                            <InputBox
                              name={"Indexation"}
                              ariaLabel=""
                              onChange={handleChange}
                              value={Indexation || ""} // Ensure default value
                              suffix={Indexation ? "%" : ""}
                              hideClearButton={true}
                              placeholder={INDEXATION_PLACEHOLDER}
                              readonly={
                                !editableFields.includes("Indexation") ||
                                (!getSKUData?.UpdateStatusCd &&
                                  showNewCostingSection)
                              }
                              onBlur={handleBlur}
                            />
                            {IndexationError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {IndexationError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="motif-col-lg">
                    <div className="motif-row right-content">
                      <div
                        className={`motif-col-lg-4 form-item ${
                          commercialStatus === "sku_retired" ||
                          commercialStatus === "sku_active"
                            ? ""
                            : "hide"
                        }`}
                      >
                        <div className="label">
                          {COMMERCIAL_STATUS}
                          <span className="required">*</span>
                        </div>
                      </div>
                      <div
                        className={`motif-col-lg-8 form-item ${
                          commercialStatus === "sku_retired" ||
                          commercialStatus === "sku_active"
                            ? ""
                            : "hide"
                        }`}
                      >
                        <div className="value">
                          <div className="inputField">
                            <SelectBox
                              options={
                                commercialStatus === "sku_active" ||
                                commercialStatus === "sku_retired"
                                  ? CommercialStatusOptionsRetired
                                  : sortOptions(CommercialStatusOptions) || []
                              }
                              value={commercialStatus}
                              // eslint-disable-next-line @typescript-eslint/no-explicit-any
                              onChange={(selectedOption: any) =>
                                handleChange({
                                  target: {
                                    name: "commercialStatus",
                                    value: selectedOption,
                                  },
                                })
                              }
                              searchPlaceholder={COMMERCIAL_PLACEHOLDER}
                              multiple={false}
                              disabled={
                                isParentActive ||
                                commercialStatus === "sku_retired" ||
                                (!getSKUData?.UpdateStatusCd &&
                                  showNewCostingSection)
                              }
                              placeholder={COMMERCIAL_PLACEHOLDER}
                            />
                            {commercialStatusError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {commercialStatusError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {getSKUData?.StatusCd === "Active" && (
                  <>
                    {!showNewCostingSection && (
                      <div className="motif-row form-item-row double-row change-request-section">
                        <div className="motif-col-lg">
                          <div className="motif-row">
                            <div className="motif-col-lg-4 form-item"></div>
                            <div className="motif-col-lg-8 form-item"></div>
                          </div>
                        </div>
                        <div className="motif-col-lg">
                          <div className="motif-row">
                            <div className="motif-col-lg-4 form-item"></div>
                            <div className="motif-col-lg-8 form-item change-request-buttonDiv">
                              <MotifButton
                                variant="primary"
                                size="small"
                                onClick={() => {
                                  const today = new Date();
                                  setMinPublishDate(
                                    calculateMinPublishDate(today),
                                  );
                                  setShowNewCostingSection(true);
                                }}
                              >
                                {REQUEST_COST_CHANGE}
                              </MotifButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {showNewCostingSection && (
                      <div className="change-request-section new-costing-section">
                        {getNewCostStatus(getSKUData?.UpdateStatusCd)}
                        <div className="new-costing-description">
                          {getNewCostDescription(getSKUData?.UpdateStatusCd)}
                        </div>

                        {/* old costing inputs */}
                        {(getSKUData?.UpdateStatusCd == "skuupdate_submitted" ||
                          getSKUData?.UpdateStatusCd ==
                            "skuupdate_pending") && (
                          <div className="motif-row new-costing-input-section">
                            <div className="motif-col-lg-3">
                              <InputBox
                                ariaLabel={OLD_COST_BASIS}
                                name={"oldCost"}
                                value={formatUSDWithCommas(oldCost || "")} // Ensure default value
                                hideClearButton={true}
                                prefix="$USD"
                                readonly={true}
                                onChange={() => {}} // to remove React warning for controlled input
                                placeholder=""
                              />
                            </div>
                            <div className="motif-col-lg-3 indexation-input-field">
                              <InputBox
                                ariaLabel={OLD_INDEXATION}
                                name={"oldIndexation"}
                                value={oldIndexation}
                                suffix={oldIndexation ? "%" : ""}
                                hideClearButton={true}
                                readonly={true}
                                onChange={() => {}} // to remove React warning for controlled input
                                placeholder={INDEXATION_PLACEHOLDER}
                              />
                            </div>
                            <div className="motif-col-lg-3">
                              <InputBox
                                ariaLabel={OLD_NSR}
                                onChange={() => {}} // to remove React warning for controlled input
                                name={"oldNSR"}
                                value={formatUSDWithCommas(oldNSR || "")} // Ensure default value
                                hideClearButton={true}
                                prefix="$USD"
                                readonly={true}
                                placeholder=""
                              />
                            </div>
                            <div className="motif-col-lg-3">
                              <MotifFormField aria-label="Form Field Date Picker">
                                <MotifLabel aria-label="Date">
                                  {`${OLD_COST_PUBLISH_DATE} (UTC)`}
                                </MotifLabel>
                                <MotifDatePicker
                                  clearIcon={null}
                                  dayPlaceholder="DD"
                                  format="dd/MM/yyyy"
                                  monthPlaceholder="MM"
                                  onChange={() => {}} // to remove React warning for controlled input
                                  value={oldPublishDate}
                                  yearPlaceholder="YYYY"
                                  disabled={true}
                                />
                                <span className="date-support-text">
                                  Last cost update or SKU publish date
                                </span>
                              </MotifFormField>
                            </div>
                          </div>
                        )}

                        <div className="motif-row new-costing-input-section">
                          <div className="motif-col-lg-3">
                            <InputBox
                              ariaLabel={NEW_COST_BASIS}
                              onBlur={handleCostChangeBlur}
                              onChange={handleNewCostChange}
                              name={"newCost"}
                              placeholder=""
                              value={formatUSDWithCommas(newCost || "")} // Ensure default value
                              hideClearButton={true}
                              error={newCostError}
                              prefix="$USD"
                              required={true}
                              readonly={
                                getSKUData?.UpdateStatusCd ==
                                  "skuupdate_submitted" ||
                                getSKUData?.UpdateStatusCd ==
                                  "skuupdate_pending"
                              }
                            />
                            {newCostError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {newCostError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="motif-col-lg-3 indexation-input-field">
                            <InputBox
                              ariaLabel={NEW_INDEXATION}
                              onChange={handleNewCostChange}
                              onBlur={handleCostChangeBlur}
                              name={"newIndexation"}
                              value={newIndexation ?? ""}
                              suffix={(newIndexation ?? "") !== "" ? "%" : ""}
                              placeholder={INDEXATION_PLACEHOLDER}
                              hideClearButton={true}
                              readonly={
                                getSKUData?.UpdateStatusCd ==
                                  "skuupdate_submitted" ||
                                getSKUData?.UpdateStatusCd ==
                                  "skuupdate_pending"
                              }
                            />
                            {newIndexationError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {newIndexationError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="motif-col-lg-3">
                            <InputBox
                              ariaLabel={NEW_NSR}
                              onChange={handleNewCostChange}
                              name={"newNSR"}
                              onBlur={handleCostChangeBlur}
                              value={formatUSDWithCommas(newNSR ?? "")}
                              hideClearButton={true}
                              prefix="$USD"
                              placeholder=""
                              readonly={
                                getSKUData?.UpdateStatusCd ==
                                  "skuupdate_submitted" ||
                                getSKUData?.UpdateStatusCd ==
                                  "skuupdate_pending"
                              }
                            />
                            {newNSRError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {newNSRError.message}
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="motif-col-lg-3">
                            <MotifFormField aria-label="Form Field Date Picker">
                              <MotifLabel aria-label="Date">
                                {`${NEW_COST_PUBLISH_DATE}`}
                                <span className="required">*</span>
                              </MotifLabel>
                              <MotifDatePicker
                                clearIcon={null}
                                dayPlaceholder="DD"
                                format="dd/MM/yyyy"
                                monthPlaceholder="MM"
                                minDate={publishDate ? undefined : new Date()}
                                onChange={handlePublishDateChange}
                                onKeyDown={handleCalendarKeyDown}
                                tileClassName={getTileClassName}
                                tileDisabled={isDateDisabled}
                                value={publishDate}
                                yearPlaceholder="YYYY"
                                disabled={
                                  getSKUData?.UpdateStatusCd ==
                                    "skuupdate_submitted" ||
                                  getSKUData?.UpdateStatusCd ==
                                    "skuupdate_pending"
                                }
                              />
                            </MotifFormField>
                            {publishDateError?.isError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                {publishDateError.message}
                              </MotifErrorMessage>
                            ) : (
                              <span className="new-publish-date-support-text">
                                Publishing occurs at 00:00 hrs UTC
                              </span>
                            )}
                          </div>
                        </div>
                        {approveNewCostError && (
                          <div className="motif-row error-grid">
                            <div className="motif-col-lg-12">
                              <NotificationGrid
                                show={true}
                                message={approveNewCostError}
                                type="error"
                              />
                            </div>
                          </div>
                        )}
                        {getSKUData?.UpdateStatusCd == "skuupdate_submitted" ||
                        getSKUData?.UpdateStatusCd == "skuupdate_pending" ? (
                          <div
                            className={`new-costing-button-section-grid ${isCancelCostActive ? "inner-grid" : ""}`}
                          >
                            <>
                              <p
                                className={`cancel-confirm-suggestion ${isCancelCostActive ? "" : "hide-cost-message"}`}
                              >
                                Are you sure you wish to cancel this update
                                request?
                              </p>
                              <div className="new-costing-button-section">
                                {isCancelCostActive ? (
                                  <>
                                    <MotifButton
                                      variant="primary"
                                      size="small"
                                      onClick={handleCancelSKUApproval}
                                    >
                                      {CANCEL_FOR_APPROVAL}
                                    </MotifButton>
                                    <MotifButton
                                      variant="secondary"
                                      size="small"
                                      onClick={() =>
                                        setIsCancelCostActive(false)
                                      }
                                    >
                                      {CANCEL}
                                    </MotifButton>
                                  </>
                                ) : (
                                  renderCancelCostUpdateBtn(publishDate)
                                )}
                              </div>
                            </>
                          </div>
                        ) : (
                          <div className="new-costing-button-section-grid appvoal-grid">
                            <div className="approval-btn-grid">
                              <MotifButton
                                variant="secondary"
                                size="small"
                                onClick={closeNewCostSection}
                              >
                                {CANCEL}
                              </MotifButton>
                              <MotifButton
                                variant="primary"
                                size="small"
                                loading={approveNewCostLoading}
                                onClick={handleSKUApproval}
                              >
                                {SUBMIT_FOR_APPROVAL}
                              </MotifButton>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}
                <div className="motif-row heading costing-label">
                  <div className="motif-col-lg-12">
                    <div className="title">{ORDER_ACKNOWLEDGEMENT}</div>
                  </div>
                </div>
                <div className="motif-row form-item-row double-row">
                  <div className="motif-col-lg">
                    <div className="motif-row">
                      <div className="motif-col-lg-4 form-item label-item">
                        <div className="label">{GLOBAL_RISK_MANAGER}</div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div
                            className={`inputField ${
                              !editableFields.includes("globalRiskManager") ||
                              (!getSKUData?.UpdateStatusCd &&
                                showNewCostingSection)
                                ? "not-editable"
                                : ""
                            }`}
                          >
                            <UserSearchSelect
                              proxyOwners={globalRiskMng}
                              name={"globalRiskManager"}
                              setUserSearchSelect={setGlobalRiskMng}
                              readOnly={
                                !editableFields.includes("globalRiskManager") ||
                                (!getSKUData?.UpdateStatusCd &&
                                  showNewCostingSection)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="motif-col-lg">
                    <div className="motif-row right-content">
                      <div className="motif-col-lg-4 form-item label-item">
                        <div className="label">{LOCAL_RISK_MANAGER}</div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div
                            className={`inputField ${
                              !editableFields.includes("localRiskManager") ||
                              (!getSKUData?.UpdateStatusCd &&
                                showNewCostingSection)
                                ? "not-editable"
                                : ""
                            }`}
                          >
                            <UserSearchSelect
                              proxyOwners={localRiskMng}
                              setUserSearchSelect={setLocalRiskMng}
                              name={"localRiskManager"}
                              readOnly={
                                !editableFields.includes("localRiskManager") ||
                                (!getSKUData?.UpdateStatusCd &&
                                  showNewCostingSection)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-row form-item-row double-row">
                  <div className="motif-col-lg">
                    <div className="motif-row">
                      <div className="motif-col-lg-4 form-item label-item">
                        <div className="label">{PRODUCT_APPROVER}</div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div
                            className={`inputField ${
                              !editableFields.includes("productApprover") ||
                              (!getSKUData?.UpdateStatusCd &&
                                showNewCostingSection)
                                ? "not-editable"
                                : ""
                            }`}
                          >
                            <UserSearchSelect
                              proxyOwners={productApproverList}
                              setUserSearchSelect={setProductApproverList}
                              name={"productApprover"}
                              readOnly={
                                !editableFields.includes("productApprover") ||
                                (!getSKUData?.UpdateStatusCd &&
                                  showNewCostingSection)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="motif-col-lg">
                    <div className="motif-row right-content">
                      <div className="motif-col-lg-4 form-item label-item">
                        <div className="label">
                          {PROVISIONING_TEAM}
                          {isNotAutoProvisioned && (
                            <span className="required">*</span>
                          )}
                        </div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div
                            className={`inputField ${
                              !editableFields.includes("deploymentApprover") ||
                              (!getSKUData?.UpdateStatusCd &&
                                showNewCostingSection)
                                ? "not-editable"
                                : ""
                            }`}
                          >
                            <UserSearchSelect
                              proxyOwners={deploymentApproverList}
                              setUserSearchSelect={setDeploymentApproverList}
                              name={"deploymentApprover"}
                              readOnly={
                                !editableFields.includes(
                                  "deploymentApprover",
                                ) ||
                                (!getSKUData?.UpdateStatusCd &&
                                  showNewCostingSection)
                              }
                              callBack={handleDeploymentApproverChange}
                            />
                            {deploymentApprover.isError ? (
                              <MotifErrorMessage
                                aria-live="assertive"
                                role="alert"
                                id="aria-error-primaryList"
                              >
                                You must enter at least one email for the
                                Provisioning Team
                              </MotifErrorMessage>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="motif-row form-item-row double-row">
                  <div className="motif-col-lg">
                    <div className="motif-row">
                      <div className="motif-col-lg-4 form-item label-item">
                        <div className="label">{CONSUMPTION_MANAGER}</div>
                      </div>
                      <div className="motif-col-lg-8 form-item">
                        <div className="value">
                          <div
                            className={`inputField ${
                              !getSKUData?.UpdateStatusCd &&
                              showNewCostingSection
                                ? "not-editable"
                                : ""
                            }`}
                          >
                            <UserSearchSelect
                              proxyOwners={consumptionManagerList}
                              setUserSearchSelect={setConsumptionManagerList}
                              name={"consumptionManager"}
                              readOnly={
                                !getSKUData?.UpdateStatusCd &&
                                showNewCostingSection
                              }
                              placement={"top"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="motif-col-lg" />
                </div>
                {hasProductError && (
                  <div className="prevent-sku-submission ">
                    <MotifIcon
                      iconFunction={IconoirInfoCircle}
                      size="20"
                      title="Order Bundle"
                      fill="#EA011D"
                    />
                    <span>{PREVENT_SKU_SUBMISSION}</span>
                  </div>
                )}
              </>
            )}
          </MotifModalBody>
          {!getSKUIsLoadingAPi && !getSKUErrorAPi && (
            <MotifModalFooter>
              <MotifButton
                variant={"secondary"}
                onClick={() => {
                  setShow(false);
                  setFormFields(initialValues);
                  setShowSuccessPage(false);
                  dispatch(resetCreateSkuState());
                  if (reloadSKUList) {
                    setReloadOnNewCreation?.(true);
                  }
                }}
              >
                {CANCEL}
              </MotifButton>
              {getSKUData?.StatusCd === "Draft" ||
              getSKUData?.StatusCd === "Rejected" ? (
                <>
                  <MotifButton
                    variant={"secondary"}
                    onClick={() => handleSave("sku_draft")}
                    loading={isSaveSKULoading}
                    disabled={isSaveSKULoading}
                  >
                    {"Save as Draft"}
                  </MotifButton>
                  <MotifButton
                    variant={"primary"}
                    onClick={() => handleSave("sku_submitted")}
                    loading={isSubmitSKULoading}
                    disabled={isSubmitSKULoading || hasProductError}
                  >
                    Submit
                  </MotifButton>
                </>
              ) : (
                <MotifButton
                  variant={"primary"}
                  loading={isSubmitSKULoading}
                  onClick={() =>
                    getSKUData.StatusCd === "Active" &&
                    commercialStatus === "sku_retired"
                      ? setIsConfirmClicked(true)
                      : handleSave(commercialStatus)
                  }
                  disabled={
                    isSubmitSKULoading ||
                    editableFields.length === 0 ||
                    (!getSKUData?.UpdateStatusCd && showNewCostingSection)
                  }
                >
                  {"Update"}
                </MotifButton>
              )}
            </MotifModalFooter>
          )}
        </>
      </MotifModal>
      {isConfirmClicked && confirmRetireSKU()}
    </div>
  );
}
